/* akuma-rsl.js - shared script for Akuma RSL sections.
   Idempotent - safe to load from multiple sections on the same page. */
(function(){
  if (window.__akuma_rsl_init) return;
  window.__akuma_rsl_init = true;

  // ----- Scroll-triggered reveals -----
  function observeReveals(root){
    var nodes = (root||document).querySelectorAll('.akuma-rsl .reveal:not([data-akr-seen])');
    nodes.forEach(function(el){ el.dataset.akrSeen='1'; io.observe(el); });
  }
  var io;
  if ('IntersectionObserver' in window){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    observeReveals();
    if ('MutationObserver' in window){
      new MutationObserver(function(){ observeReveals(); })
        .observe(document.body, { childList:true, subtree:true });
    }
  } else {
    document.querySelectorAll('.akuma-rsl .reveal').forEach(function(el){ el.classList.add('in'); });
  }

  // ----- Hero parallax (any element with data-akr-parallax) -----
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var ticking = false;
    function update(){
      var y = window.scrollY;
      document.querySelectorAll('[data-akr-parallax]').forEach(function(el){
        el.style.transform = 'translate3d(0,' + (y*0.25) + 'px,0) scale(' + (1 + y*0.0002) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }
})();
